export default __webpack_public_path__ + "static/media/profile-pic.cf465819.jpeg";